<template>
  <div class="vux-header">
    <div class="vux-header-left">
      <a class="vux-header-back" @click.preventDefault v-show="leftOptions.showBack" :transition="transition" @click="onClickBack">{{leftOptions.backText}}</a>
      <div class="left-arrow" @click="onClickBack" v-show="leftOptions.showBack" :transition="transition"></div>
      <slot name="left"></slot>
    </div>
    <h1 class="vux-header-title" @click="$emit('on-click-title')"><span v-show="title" :transition="transition">{{title}}</span><slot></slot></h1>
    <div class="vux-header-right">
      <a class="vux-header-more" @click.preventDefault @click="$emit('on-click-more')" v-if="rightOptions.showMore"></a>
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftOptions: {
      type: Object,
      default () {
        return {
          showBack: true,
          backText: 'Back',
          preventGoBack: false
        }
      }
    },
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default () {
        return {
          showMore: false
        }
      }
    }
  },
  methods: {
    onClickBack () {
      if (this.leftOptions.preventGoBack) {
        this.$emit('on-click-back')
      } else {
        window.history.back()
      }
    }
  }
}
</script>

<style lang="less">
@import '../../styles/variable.less';
@import '../../styles/cui/widget/cui_cell/cui_cell_global';
.vux-header {
  position: relative;
  padding: 3/@w 0;
  box-sizing: border-box;
  background-color: @x-header-background-color;
}
.vux-header .vux-header-title,.vux-header h1 {
  margin: 0 88/@w;
  margin-left: 100/@w;
  line-height: 40/@w;
  text-align: center;
  height: 40/@w;
  font-size: 18/@w;
  font-weight: 400;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: @x-header-title-color;
}
.vux-header .vux-header-title > span {
  display: inline-block;
}
.vux-header .vux-header-left,.vux-header .vux-header-right {
  position: absolute;
  top: 14/@w;
  display: block;
  font-size: 14/@w;
  line-height: 21/@w;
  color: @x-header-text-color;
}
.vux-header .vux-header-left a,.vux-header .vux-header-left button,.vux-header .vux-header-right a,.vux-header .vux-header-right button {
  float: left;
  margin-right: 8/@w;
  color: @x-header-text-color;
}
.vux-header .vux-header-left a:active,.vux-header .vux-header-left button:active,.vux-header .vux-header-right a:active,.vux-header .vux-header-right button:active {
  opacity: .5
}
.vux-header .vux-header-left {
  left: 18/@w
}
.vux-header .vux-header-left .vux-header-back {
  padding-left: 16/@w
}
.vux-header .vux-header-left .left-arrow {
  position: absolute;
  width: 30/@w;
  height: 30/@w;
  top: -5/@w;
  left: -5/@w;

  &:before {
    content: "";
    position: absolute;
    width: 12/@w;
    height: 12/@w;
    border: 1px solid @x-header-arrow-color;
    border-width: 1px 0 0 1px;
    transform: rotate(315deg);
    top: 8/@w;
    left: 7/@w;
  }
}
.vux-header .vux-header-right {
  right: 15/@w
}
.vux-header .vux-header-right a,.vux-header .vux-header-right button {
  margin-left: 8/@w;
  margin-right: 0
}
.vux-header .vux-header-right .vux-header-more:after {
  content: "\2022\0020\2022\0020\2022\0020";
  font-size: 16/@w;
}
.vux-header-fade-in-right-enter {
  animation: fadeinR .5s;
}
.vux-header-fade-in-left-enter {
  animation: fadeinL .5s;
}
@keyframes fadeinR{
  0%{opacity:0;transform:translateX(80/@w);}
  100%{opacity:1;transform:translateX(0);}
}
@keyframes fadeinL{
  0%{opacity:0;transform:translateX(-80/@w);}
  100%{opacity:1;transform:translateX(0);}
}
</style>



// WEBPACK FOOTER //
// x-header.vue?754696e0